import React from 'react';
import { Avatar, Box } from '@mui/material';

/**
 * Renders a college logo. If logoUrl is provided, shows the image.
 * Otherwise shows a styled avatar with the abbreviation and brand color.
 * Uses a rectangular container so wide logos display properly.
 */
function CollegeLogo({ college, height = 120 }) {
  if (college.logoUrl) {
    const scale = college.logoScale || 1;
    return (
      <Box
        sx={{
          width: '100%',
          height: height,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 1,
        }}
      >
        <Box
          component="img"
          src={college.logoUrl}
          alt={`${college.name} logo`}
          sx={{
            maxWidth: `${100 * scale}%`,
            maxHeight: `${100 * scale}%`,
            objectFit: 'contain',
          }}
        />
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%', height: height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Avatar
        sx={{
          width: height * 0.8,
          height: height * 0.8,
          bgcolor: college.color || '#1e3a8a',
          fontSize: height * 0.25,
          fontWeight: 800,
          letterSpacing: 1,
        }}
      >
        {college.abbreviation}
      </Avatar>
    </Box>
  );
}

export default CollegeLogo;
